import {Model} from "./model";

export class Manufacturer extends Model {

    id: number;
    name: string;
    seo_name: string;
    url: string;
    model_count: number;

    map = {};

    constructor(data) {
        super();
        this.setData(data);
    }
}
